import { AppBar, Grid, Toolbar, IconButton, Popover } from "@mui/material";
import React, { useState } from "react";
import Logo from "../../Assets/images/logov2.png";
import { Link } from "react-router-dom";
import Search from "../search/Search";
import { useMediaQuery } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Icon from "../icon/Icon";
import Navbarmenu from "./navbarmenu/Navbarmenu";
import Menus from "../menus/Menus";

const Navbar = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    const isLgScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handlePopoverClose = () => {
        setOpen(false);
    };

    return (
        <AppBar position="sticky" elevation={2}>
            <Toolbar className="flex justify-between">
                <img src={Logo} alt="logo" className="w-[120px]" />

               {/*<Grid container justifyContent={isLgScreen ? "center" : "flex-end"} flexGrow={1}>
                    {isLgScreen ? (
                        <Search />
                    ) : (
                        <IconButton onClick={handlePopoverOpen} color="inherit">
                            <SearchIcon color="primary" />
                        </IconButton>
                    )}
                </Grid> */} 

                <div className=" lg:flex items-center gap-5" style={{display: 'inline-block'}}>
                    <Grid item  style={{ display: 'inline-block', marginRight: '25px' }}>
                        <Link to="/signup" className="font-medium hover:text-primary flex items-center gap-1">
                            <Icon name="signup" layoutClass="h-5 w-5 text-primary" />
                            Signup
                        </Link>
                    </Grid>
                    <Grid item  style={{display: 'inline-block'}}>
                        <Link to="/login" className="font-medium hover:text-primary flex items-center gap-1">
                            <Icon name="login" layoutClass="h-5 w-5 text-primary" />
                            Login
                        </Link>
                    </Grid>
                </div>

          

                 {/*   <Navbarmenu />*/ }
            </Toolbar>
             {/*  <Menus />*/ }
            <Popover
                className="block md:hidden"
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{
                    style: {
                        width: '90%', 
                        maxWidth: '100%', 
                        padding: 0, 
                    },
                }}
                style={{
                    background: "rgba(0, 0, 0, 0.5)"
                }}
            >
                <Search />
            </Popover>
        </AppBar>
    );
};

export default Navbar;
